import React from "react";
import { Button } from "./ui/button";
import { useParams, useNavigate } from "react-router";

import useProjectActions from "../hooks/useProjectActions";
import { deleteFileFromURI } from "../helpers/storageHelpers";
import Modal from "../Modal";
import useFirebaseFirings from "../hooks/useFirebaseFirings";
import useFirebaseProject from "../hooks/useFirebaseProject";

const ProjectDeletePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const project = useFirebaseProject(id!);
  const firings = useFirebaseFirings();
  const { deleteProject } = useProjectActions();

  const my_firings = Object.values(firings ?? {}).filter(
    (firing: any) => firing?.project_id === id
  );

  const deleteProjectIncludingImages = (project: any) => {
    if (project.photo) {
      deleteFileFromURI(project.photo);
    }
    project.photos &&
      project.photos.forEach((photo: any) => {
        if (photo?.photo) {
          deleteFileFromURI(photo.photo);
        }
        if (photo?.photo256?.uri) {
          deleteFileFromURI(photo.photo256.uri);
        }
        if (photo?.photo1024?.uri) {
          deleteFileFromURI(photo.photo1024.uri);
        }
      });
    deleteProject(project.id);
  };

  const actions = () => (
    <React.Fragment>
      <Button
        variant="destructive"
        disabled={my_firings.length !== 0}
        onClick={() => {
          if (my_firings.length === 0) {
            deleteProjectIncludingImages(project);
          }
        }}
      >
        Delete
      </Button>
      <Button variant="outline" onClick={() => navigate(-1)}>Cancel</Button>
    </React.Fragment>
  );

  const renderContent = () => {
    if (!project || !firings) {
      return <div>Loading...</div>;
    }
    if (my_firings.length !== 0) {
      return (
        <div>
          This project still has some firings. You can't delete the project without first deleting
          every firing.
        </div>
      );
    }

    return (
      <React.Fragment>
        <div>Name:{project.name}</div>
      </React.Fragment>
    );
  };

  return (
    <Modal
      title="Delete Project"
      content={renderContent()}
      actions={actions()}
      onDismiss={() => navigate(-1)}
    />
  );
};

export default ProjectDeletePage;
